import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#user-off-clip0_2249_1729)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "M1.707.293A1 1 0 0 0 .293 1.707l7.025 7.025q.018.072.046.143a5.01 5.01 0 0 0 2.478 2.636 1 1 0 0 0 .35.095L12.586 14H8a5 5 0 0 0-5 5v2a1 1 0 0 0 1 1h16c.17 0 .33-.042.47-.117l1.823 1.824a1 1 0 0 0 1.414-1.414zM18.586 20l-4.004-4.003L14.5 16H8a3 3 0 0 0-3 3v1zM12 4c-.896 0-1.7.391-2.25 1.016a1 1 0 1 1-1.5-1.324 5 5 0 1 1 6.875 7.21 1 1 0 1 1-1.25-1.56A3 3 0 0 0 12 4",
        "clip-rule": "evenodd"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "user-off-clip0_2249_1729" }, [
        _createElementVNode("path", {
          fill: "currentColor",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }